<template>
  <span
    @click="handleClick"
    :class="['chip', { chip_clickable: clickable }]"
    :style="{ background, color, fill: color }"
  >
    <slot name="iconChip"></slot>
    <span class="chip__name">{{ value }}</span>
    <Icon
      v-if="hasIcon"
      @click.stop="handleIconClick"
      class="chip__icon"
      color="inherit"
      :hover-color="hoverColor"
      :value="icon"
    />
  </span>
</template>

<script>
import Icon from './../Icon';

export default {
  name: 'Chip',
  components: { Icon },
  props: {
    background: { default: 'var(--color-1)', type: String },
    clickable: { default: false, type: Boolean },
    color: { default: '#fff', type: String },
    hasIcon: { default: true, type: Boolean },
    hoverColor: { default: 'var(--color-1)', type: String },
    icon: { default: 'cancel', type: String },
    value: { default: null, type: String },
  },
  emits: {
    click: null,
    iconClick: null,
  },
  methods: {
    handleClick(e) {
      this.clickable && this.$emit('click', e);
    },
    handleIconClick() {
      this.$emit('iconClick');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Chip';
</style>
